module.exports = __webpack_public_path__ + "img/ascend_gold44.72186aeb.png";